import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "14",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1.59 13.25a1.45 1.45 0 0 1-1.064-.443 1.45 1.45 0 0 1-.442-1.064V2.256q0-.62.442-1.063A1.45 1.45 0 0 1 1.59.75h8.839a1.51 1.51 0 0 1 1.205.595L15.917 7l-4.283 5.655a1.513 1.513 0 0 1-1.205.595zm0-1.25h8.839a.3.3 0 0 0 .116-.024.3.3 0 0 0 .092-.072L14.355 7l-3.718-4.904a.3.3 0 0 0-.092-.072.3.3 0 0 0-.116-.024H1.59a.25.25 0 0 0-.184.072.25.25 0 0 0-.072.184v9.487a.25.25 0 0 0 .072.185.25.25 0 0 0 .184.072",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }